__turbopack_context__.v({
  "passport_transfer_one_membership": "PassportTransferOneMembership-module-scss-module__FHKURW__passport_transfer_one_membership",
  "passport_transfer_one_membership__buttons": "PassportTransferOneMembership-module-scss-module__FHKURW__passport_transfer_one_membership__buttons",
  "passport_transfer_one_membership__description": "PassportTransferOneMembership-module-scss-module__FHKURW__passport_transfer_one_membership__description",
});
